import { computePosition, flip, offset, size } from '@floating-ui/dom';
import { createComponent } from '@front/utils/alpine';

async function position (triggerEl: HTMLElement, tooltipEl: HTMLElement) {
    const {
        x,
        y,
    } = await computePosition(triggerEl, tooltipEl, {
        placement: 'top-start',
        middleware: [
            flip(),
            offset(5),
            size({
                apply({ reference }) {
                    Object.assign(tooltipEl.style, {
                        width: `${reference.width}px`,
                    });
                },
            }),
        ],
    });

    Object.assign(tooltipEl.style, {
        left: `${x}px`,
        top: `${y}px`,
    });
}

export default createComponent(() => ({
    el: null as HTMLElement | null,
    target: null as HTMLElement | null,
    isOpen: false,

    setup (el: HTMLElement, target: HTMLElement) {
        this.el = el;
        this.target = target;
    },

    toggle (force: boolean) {
        if (!this.el || !this.target) {
            return;
        }

        this.isOpen = force == undefined ? !this.isOpen : force;
        this.isOpen ? position(this.el, this.target) : null;

        this.target.classList.toggle('block', this.isOpen);
        this.target.classList.toggle('hidden', !this.isOpen);
    },
}));
